import { mapData } from "@/utilities/DataMapping";
import { IResource, Resource } from "@/model/Resource";
import { IVisit, Visit } from "@/model/Visit";
import { IRegistrationAnswer, RegistrationAnswer } from "./RegistrationAnswer";
import { IVisitAnswer, VisitAnswer } from "./VisitAnswer";
import Utils from "@/utilities/Utils";

export interface IVisitSearchResult {
    clientName: string;
    siteID: string;
    siteName: string;
    briefingName: string;
    pathwayDescription: string;
    visit: IVisit;
    siteImage: IResource;
}

export class VisitSearchResult implements IVisitSearchResult {

    constructor(data?: IVisitSearchResult) {
        if (data) this.update(data);
    }

    update(data: IVisitSearchResult): VisitSearchResult {
        mapData(data, {
            root: () => this,
            visit: (data: IVisit) => this.visit.update(data),
            siteImage: (data: IResource) => this.siteImage.update(data)
        });
        return this;
    }

    clientName: string = "";
    siteID: string = Utils.emptyGuidValue;
    siteName: string = "";
    briefingName: string = "";
    pathwayDescription: string = "";
    answerCount: number = 0;
    correctCount: number = 0;
    visit: Visit = new Visit();
    siteImage: Resource = new Resource();
}